<template>
  <my-dialog ref="selectGoods" title="选择商品" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%" append-to-body>
    <div style="margin-top: -15px">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="商品信息：">
          <el-cascader size="small" v-model="formInline.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
            @change="handleTypeChange" placeholder="请选择商品信息" clearable filterable></el-cascader>
        </el-form-item>
        <el-form-item label="球镜">
          <el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable filterable size="small" :disabled="!isSelectDuShu">
            <el-option v-for="item in qiuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="柱镜">
          <el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable filterable size="small" :disabled="!isSelectDuShu">
            <el-option v-for="item in zhuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @selection-change="handleSelectionChange" border :highlight="selectType === 1"
        :highlight-current-row="selectType === 1" @current-change="handleGoodsCurrentChange">
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitSelect">
        确认
      </el-button>
    </div>
  </my-dialog>
</template>

<script>
import {
  GetGoodsInfoPageList,
  GetAllGoodsTypeTreePageList,
  GetGoodsParamsList,
} from "../../../api/baseDataApi.js";
export default {
  props: {
    isSelectDuShu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        typeKeyId: "",
        paramsKeyId1: "",
        paramsKeyId2: "",
      },
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click", // 展开方式
      },
      goodsTypeList: [],
      qiuJingList: [],
      zhuJingList: [],
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "keyId",
          label: "全选",
          align: "center",
          fixed: "left",
          width: "55",
          isKeep: true,
          selection: true,
        },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "type",
          label: "商品品牌",
          isKeep: true,
          width: "120",
          align: "center",
        },
        {
          prop: "name",
          label: "商品名称",
          width: "150",
          align: "center",
        },
        {
          prop: "unit",
          label: "单位",
          width: "60",
          align: "center",
        },
        {
          prop: "qiuJing",
          label: "球镜",
          width: "80",
          align: "center",
        },
        {
          prop: "zhuJing",
          label: "柱镜",
          width: "80",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          minWidth: "120",
          align: "center",
        },
      ],
      selectType: 1, //1:单选商品；2：多选商品
    };
  },
  // 注册组件
  components: {},
  created() {
    this.GetAllGoodsTypeTreePageList();
    this.GetGoodsParamsList();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    showSelectGoodsDialog(type, paramsKeyId1 = "", paramsKeyId2 = "") {
      this.showDialog = true;
      this.selectType = type;
      if (type === 1) {
        //如果listColumns的第一个prop是keyId,去掉listColumns的第一个数据
        if (this.listColumns[0].prop === "keyId") {
          this.listColumns.shift();
        }
      } else {
        //添加listColumns的第一个数据
        if (this.listColumns[0].prop != "keyId") {
          this.listColumns.unshift({
            prop: "keyId",
            label: "全选",
            align: "center",
            fixed: "left",
            width: "55",
            isKeep: true,
            selection: true,
          });
        }
      }
      // 初始列
      this.getCheckBox(this.listColumns.map((item) => item.label));
      if (paramsKeyId1) {
        this.formInline.paramsKeyId1 = this.qiuJingList.find(item => item.paramsValue === paramsKeyId1).keyId;
      }
      if (paramsKeyId2) {
        this.formInline.paramsKeyId2 = this.zhuJingList.find(item => item.paramsValue === paramsKeyId2).keyId;
      }
      this.search();
    },
    changePages() { },
    // 表格多选时间处理
    handleSelectionChange(val) {
      if (val == null || val == undefined || val.length == 0) {
        this.selectionList = [];
      } else {
        this.selectionList = val;
      }
    },
    // 表格单选事件处理
    handleGoodsCurrentChange(currentRow) {
      if (this.selectType === 2) {
        return;
      }
      if (currentRow == null || currentRow == undefined || currentRow == "") {
        this.selectionList = [];
      } else {
        this.selectionList = [currentRow];
      }
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetGoodsInfoPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 关闭
    closeDialog() {
      this.showDialog = false;
      this.selectionKeyId = "";
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.selectionList = [];
      this.listData = [];
    },
    // 确认选择
    submitSelect() {
      if (this.selectionList.length == 0) {
        this.$message.error("请选择商品");
        return;
      }
      this.$parent.chooseGoods(this.selectionList);
      this.closeDialog();
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({
        isOnline: true,
      })
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.formInline.typeKeyId = value[value.length - 1];
      } else {
        this.formInline.typeKeyId = "";
      }
      this.search();
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #f50707;
  border: 1px solid #dfbce2;
  color: rgb(252, 252, 252);
  border-radius: 2px;
}
</style>